<template>
  <div>
    <el-cascader
      :value="ids"
      :options="items"
      @change="handleItemChange"
      @expand-change="handleExpandChange"
      :props="props"
      :placeholder="placeholder"
      :clearable="clearable"
      style="width:100%;"
    ></el-cascader>
  </div>
</template>

<script>
export default {
  name: 'GrammarTypeSelect',
  props: {
    value: Number,
    type: Object,
    placeholder: {
      type: String,
      default: '请选择'
    },
    clearable: Boolean
  },
  data () {
    return {
      pid: null,
      ids: [],
      items: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'items',
        checkStrictly: true
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    value (newVal) {
      if (newVal !== this.pid) {
        this.ids = []
        this.initOptions()
      } else if(newVal === null && this.ids.length > 0) {
        this.ids = []
      } else if(this.ids.length === 0) {
        this.initOptions()
      }
    }
  },
  methods: {
    initOptions () {
      if (this.ids.length > 0 || !this.value) return
      this.initSelect(this.items)
    },
    initSelect (items) {
      for(let n of items) {
        if (n.id === this.value) {
          this.ids.push(n.id)
          break;
        } else if (this.type && n.root === this.type.root && n.lft < this.type.lft && n.rgt > this.type.rgt){
          this.loadNodes(n.items, n.id).then((res) => {
            this.ids.push(n.id)
            this.initSelect(n.items)
          })
        }
      }
    },
    fetchData () {
      this.$http.get(this.$urls.grammar_type_treelist).then(res => {
        this.items = res.data.map(n => {
          return this.initItem(n)
        })
        this.initOptions()
      })
    },
    initItem (n) {
      return {
        id: n.id,
        name: n.name,
        root: n.root,
        lft: n.lft,
        rgt: n.rgt,
        items: n.rgt - n.lft === 1 ? null : []
      }
    },
    handleExpandChange (val) {
      let node = this
      val.forEach(id => {
        node = node.items.find(n => n.id === id)
      })
      this.pid = val[val.length - 1]
      this.loadNodes(node.items, this.pid)
    },
    handleItemChange (val) {
      this.pid = val[val.length - 1]
      this.$emit('input', this.pid)
    },
    loadNodes (items, pid) {
      if (items !== null && items.length === 0) {
        return this.$http.get(this.$urls.grammar_type_treelist, {
          params: { pid }
        }).then(res => {
          res.data.forEach(n => {
            items.push(this.initItem(n))
          })
        })
      } else {
        return Promise.resolve([])
      }
    }
  }
}
</script>
